import { FrontPageTranslations } from "./types";

export const deTranslations: FrontPageTranslations = {
    joinClass: "Session beitreten",
    reviewPreviousGames: "Vorherige Sessions überprüfen",
};
